import { Outlet } from 'react-router-dom'
import Nav from './Nav.jsx'
import Footer from './Footer.jsx'
import CartSidebar from './CartSidebar.jsx'
import ScrollToTop from './ScrollToTop.jsx'
import DisclaimerBanner from './DisclaimerBanner.jsx'

export default function Layout() {
  return (
    <>
      <div className="grain-overlay" aria-hidden="true" />
      <ScrollToTop />
      <DisclaimerBanner />
      <Nav />
      <main>
        <Outlet />
      </main>
      <Footer />
      <CartSidebar />
    </>
  )
}
